import { render, staticRenderFns } from "./SectionTitleWithIcon.vue?vue&type=template&id=7721f728&scoped=true&"
import script from "./SectionTitleWithIcon.vue?vue&type=script&lang=ts&"
export * from "./SectionTitleWithIcon.vue?vue&type=script&lang=ts&"
import style0 from "./SectionTitleWithIcon.vue?vue&type=style&index=0&id=7721f728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7721f728",
  null
  
)

export default component.exports